import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import CombinePanel from '../../../components/Editor/CombinePanel';

interface CombinePanelContainerProps {
	importManagerId: string;
	isDisplayed: boolean;
}

const mapStateToProps = (state: StoreState, ownProps: CombinePanelContainerProps) => {
	const {
		importManager: { byId },
	} = state;
	const { isDisplayed, importManagerId } = ownProps;

	return {
		isDisplayed,
		isImporting: !!byId[importManagerId],
	};
};

export default connect(mapStateToProps)(CombinePanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/CombinePanel/index.tsx